import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {retry} from 'rxjs/operators';
import {FusionAuthService} from '../services/fusion-auth';

@Injectable({
  providedIn: 'root',
})
export class FusionAuthGuard  {
  constructor(private router: Router, private fusionAuth: FusionAuthService) {
  }

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise<boolean>(async resolve => {
      let routeRoles, role;
      if (this.fusionAuth.Profile !== undefined && this.fusionAuth.Profile !== null) {
        try {
          role = this.fusionAuth.Profile?.registrations[0].roles[0];
          routeRoles = next.firstChild !== null && next.firstChild.firstChild !== null ? next.firstChild.firstChild.data.roles :
            next.firstChild !== null ? next.firstChild.data.roles : next.data.roles;
          if (this.fusionAuth.IsLoggedIn === 'false') {
            await this.router.navigateByUrl('/login');
            return resolve(false);
          }
        } catch {
          await this.router.navigateByUrl('/login');
          return resolve(false);
        }

        if (this.fusionAuth.getToken()) {
          const tokenValidation = await this.fusionAuth.validateJWT().toPromise();
          if (tokenValidation.status != 200) {
            if (this.fusionAuth.getRefreshToken()) {
              await this.fusionAuth.exchangeRefreshTokenForJWT();
            } else if (this.router.url !== '/login') {
              await this.router.navigateByUrl('/login');
            }
          }
        } else if (this.router.url !== '/login') {
          await this.router.navigateByUrl('/login');
        }

        if (this.fusionAuth.IsLoggedIn === 'true' && routeRoles && routeRoles.indexOf(role) !== -1) {

          return resolve(true);
        } else {
          await this.router.navigateByUrl('/login');
        }
      } else {
        await this.router.navigateByUrl('/login');
      }
      return resolve(false);
    });
  }
}
